import { z } from 'zod'

export const feedbackCommentSchema = z.object({
  text: z
    .string()
    .trim()
    .min(1, 'Bitte geben Sie einen Kommentar ein.')
    .max(2000, 'Der Kommentar darf höchstens 2.000 Zeichen haben.'),
})

export type FeedbackCommentFormValues = z.infer<typeof feedbackCommentSchema>

export const feedbackRejectionSchema = z.object({
  grund: z
    .string()
    .trim()
    .min(1, 'Bitte begründen Sie die Ablehnung kurz.')
    .max(2000, 'Die Begründung darf höchstens 2.000 Zeichen haben.'),
})

export type FeedbackRejectionFormValues = z.infer<typeof feedbackRejectionSchema>

export const feedbackImplementationSchema = z.object({
  notiz: z
    .string()
    .trim()
    .min(1, 'Bitte beschreiben Sie kurz, was umgesetzt wurde.')
    .max(2000, 'Die Nachricht darf höchstens 2.000 Zeichen haben.'),
})

export type FeedbackImplementationFormValues = z.infer<
  typeof feedbackImplementationSchema
>
